<template>
    <div class="Office" v-if="lang">
        <md-whiteframe class="shadow shadow-faint">
            <div class="search search--field">
                <div class="icon">
                    <md-icon>search</md-icon>
                </div>
                <div class="input">
                    <input type="text" v-model="search.query" :placeholder="translate.pages.subordinates.index.search" style="outline:0;">
                    <span class="status">{{ searchIndicator }}</span>
                </div>
                <md-button v-if="addButton" class="md-icon-button md-raised button" @click.native="openDialog('add')" ref="btnOpen">
                    <md-icon>add</md-icon>
                </md-button>
                <md-button v-else class="md-icon-button md-raised button-remove" @click.native="removeSubordinates">
                    <md-icon>clear</md-icon>
                </md-button>
            </div>
        </md-whiteframe>
        <div class="table table--office table-mobile has-status table--subordinate">
            <div v-if="roles.length < 1">
                <!-- FIXME -->
                <h3 class="not-found mini-found help_message">Antes de Agregar un Usuario debe crear un Rol para asignarle.<br><b>Por ejemplo:</b> Prestador, Asistente, Secretaria, etc..<br>
                <router-link class="md-button md-raised md-primary md-size btn--blue" style="line-height: 45px;" :to="{path: '/'+$route.params.country+'/subordinate/role'}">Ir a Agregar Rol <md-icon>add</md-icon></router-link>
                </h3>
            </div>
            <div v-if="subordinates.length > 0">
                <md-table-card class="table--wrap">
                    <md-table md-sort="name" @sort="onSort" md-sort-by="name" @select="onSelect">
                        <md-table-header>
                            <md-table-row>
                                <md-table-head class="td-sort-name center-mobile" md-sort-by="name">{{translate.pages.subordinates.index.fields.name}}</md-table-head>
                                <md-table-head class="hidden-mobile" md-sort-by="code">{{translate.pages.subordinates.index.fields.code}}</md-table-head>
                                <md-table-head class="hidden-mobile" md-sort-by="phone">{{translate.pages.subordinates.index.fields.phone}}</md-table-head>
                                <md-table-head class="hidden-mobile">{{translate.pages.subordinates.index.fields.roles_profile}}</md-table-head>
                                <md-table-head class="text-center hidden-mobile">{{translate.pages.subordinates.index.fields.actions}}</md-table-head>
                            </md-table-row>
                        </md-table-header>
                        <md-table-body>
                            <md-table-row v-for="(row, rowIndex) in subordinates" :key="rowIndex" :md-item="row" md-selection>
                                <md-table-cell class="name--cell">
                                    <div class="img">
                                        <img :src="srcImage(row.image)">
                                    </div>
                                    <span class="name">{{ row.name }} {{ row.lastname }} {{ row.lastname2 }}</span>
                                    <span class="subname visible-mobile">{{ row.code }}</span>
                                </md-table-cell>
                                <md-table-cell class="hidden-mobile">
                                    <span>{{ row.code }}</span>
                                </md-table-cell>
                                <md-table-cell class="hidden-mobile">
                                    <span>{{ row.phone }}</span>
                                </md-table-cell>
                                <md-table-cell class="static-mobile">
                                    <span class="status" v-for="profile in row.user.roles" :key="profile.id" :value="profile.id">{{ profile.display_name }}</span>
                                </md-table-cell>
                                <md-table-cell class="actions">
                                    <md-icon class="icon-edit raised" @click.native="openDialog('edit', row, rowIndex)">edit</md-icon>
                                    <md-icon class="icon-delete raised" @click.native="remove(row, rowIndex)">delete</md-icon>
                                </md-table-cell>
                            </md-table-row>
                        </md-table-body>
                    </md-table>
                </md-table-card>
            </div>
            <div v-else>
                <h3 class="not-found mini-found" v-if="search.isQuery">{{translate.pages.subordinates.index.no_found}} "<strong>{{ search.query }}".</strong></h3>
                <h3 v-else>
                    <span class="not-found mini-found" v-if="fetchData">{{translate.pages.subordinates.index.no_records}}</span>
                    <span v-else>
                        <div class="sk-rotating-plane"></div>
                    </span>
                </h3>
            </div>
        </div>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="add"
            :md-click-outside-to-close="close"
            :md-esc-to-close="close">
            <md-dialog-content>
                <h3 class="dialog--title">{{translate.pages.subordinates.add.title}}</h3>
                <hr>
                <div class="content-main">
                    <md-layout md-gutter class="modal-wrap">
                        <md-layout md-flex="100" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.profile.invalid }">
                                <label for="profile">{{translate.pages.subordinates.add.fields.roles_profile}}</label>
                                <md-select id="profile" v-model="newSubordinate.profile" required>
                                    <md-option v-for="profile in roles" :key="profile.id" :value="profile.id">{{ profile.display_name }}</md-option>
                                </md-select>
                                <span class="md-error" v-if="errors.profile.invalid">{{ errors.profile.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex="100" class="container">
                            <div class="multiple">
                                <p class="title">{{translate.pages.subordinates.add.fields.offices}}</p>
                                <div class="select">
                                    <md-checkbox class="option checkbox-list" v-for="office in offices" :key="office.id" @change="onChosen($event,office.id)" v-model="office.checked" required>{{ office.name }}</md-checkbox>
                                </div>
                            </div>
                            <span style="color:#ff5722" class="md-error" v-if="errors.offices.invalid">{{ errors.offices.msg }}</span>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.rut.invalid }">
                                <label>{{translate.pages.subordinates.add.fields.code}}</label>
                                <md-input type="text" v-model="newSubordinate.rut" required></md-input>
                                <span class="md-error" v-if="errors.rut.invalid">{{ errors.rut.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.name.invalid }">
                                <label>{{translate.pages.subordinates.add.fields.name}}</label>
                                <md-input type="text" v-model="newSubordinate.name" required></md-input>
                                <span class="md-error" v-if="errors.name.invalid">{{ errors.name.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.lastname.invalid }">
                                <label>{{translate.pages.subordinates.add.fields.lastname}}</label>
                                <md-input type="text" v-model="newSubordinate.lastname"></md-input>
                                <span class="md-error" v-if="errors.lastname.invalid">{{ errors.lastname.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.lastname2.invalid }">
                                <label>{{translate.pages.subordinates.add.fields.lastname2}}</label>
                                <md-input type="text" v-model="newSubordinate.lastname2"></md-input>
                                <span class="md-error" v-if="errors.lastname2.invalid">{{ errors.lastname2.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.phone.invalid }">
                                <label>{{translate.pages.subordinates.add.fields.phone}}</label>
                                <md-input type="text" v-model="newSubordinate.phone" required></md-input>
                                <span class="md-error" v-if="errors.phone.invalid">{{ errors.phone.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.email.invalid }">
                                <label>{{translate.pages.subordinates.add.fields.email}}</label>
                                <md-input type="text" v-model="newSubordinate.email" required></md-input>
                                <span class="md-error" v-if="errors.email.invalid">{{ errors.email.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="modal--footer">
                <md-button style="padding: 0 15px;" class="float-l md-primary md-size sm-size btn--cancel" @click.native="closeDialog('add')">{{translate.pages.subordinates.add.cancel_btn}}</md-button>
                <md-button style="padding: 0 15px;" class="float-r md-primary md-size sm-size btn--blue" @click.native="closeDialog('add', true)" :disabled="process">{{translate.pages.subordinates.add.accept_btn}}</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="edit"
            :md-click-outside-to-close="close"
            :md-esc-to-close="close">
            <md-dialog-content>
                <h3 class="dialog--title">{{translate.pages.subordinates.edit.title}}</h3>
                <hr>
                <div class="content-main">
                    <md-layout md-gutter class="modal-wrap">
                        <md-layout md-flex-xsmall="100" md-flex="30" class="container">
                            <div class="picture">
                                <img :src="path" style="max-height:160px; margin-top:1em">
                                <div class="icon" @click="uploadAvatarIcon">
                                    <md-icon>photo_camera</md-icon>
                                </div>
                            </div>
                            <form id="formAvatar" style="display:none;" method="POST" enctype="multipart/form-data">
                                <input id="fileAvatar" type="file" name="avatar" @change="onAvatarChange">
                                <button type="submit"></button>
                            </form>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="70" class="container">
                            <md-layout md-flex="100">
                                <md-input-container :class="{ 'md-input-invalid' : errors.profile.invalid }">
                                    <label for="profile">{{translate.pages.subordinates.edit.fields.roles_profile}}</label>
                                    <md-select id="profile" v-model="currentSubordinate.user.roles[0].id" required>
                                        <md-option v-for="profile in roles" :key="profile.id" :value="profile.id">{{ profile.display_name }}</md-option>
                                    </md-select>
                                    <span class="md-error" v-if="errors.profile.invalid">{{ errors.profile.msg }}</span>
                                </md-input-container>
                            </md-layout>
                            <md-layout md-flex="100">
                                <div class="multiple">
                                    <p class="title">{{translate.pages.subordinates.edit.fields.offices}}</p>
                                    <div class="select-edit">
                                        <md-checkbox class="option checkbox-list" v-for="office in offices" :key="office.id" @change="onChosen($event,office.id)" v-model="office.checked" required>{{ office.name }}</md-checkbox>
                                    </div>
                                </div>
                                <span style="color:#ff5722" class="md-error" v-if="errors.offices.invalid">{{ errors.offices.msg }}</span>
                            </md-layout>
                        </md-layout>

                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.rut.invalid }">
                                <label>{{translate.pages.subordinates.edit.fields.code}}</label>
                                <md-input type="text" v-model="currentSubordinate.code" required></md-input>
                                <span class="md-error" v-if="errors.rut.invalid">{{ errors.rut.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.name.invalid }">
                                <label>{{translate.pages.subordinates.edit.fields.name}}</label>
                                <md-input type="text" v-model="currentSubordinate.name" required></md-input>
                                <span class="md-error" v-if="errors.name.invalid">{{ errors.name.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.lastname.invalid }">
                                <label>{{translate.pages.subordinates.edit.fields.lastname}}</label>
                                <md-input type="text" v-model="currentSubordinate.lastname"></md-input>
                                <span class="md-error" v-if="errors.lastname.invalid">{{ errors.lastname.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.lastname2.invalid }">
                                <label>{{translate.pages.subordinates.edit.fields.lastname2}}</label>
                                <md-input type="text" v-model="currentSubordinate.lastname2"></md-input>
                                <span class="md-error" v-if="errors.lastname2.invalid">{{ errors.lastname2.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.phone.invalid }">
                                <label>{{translate.pages.subordinates.edit.fields.phone}}</label>
                                <md-input type="text" v-model="currentSubordinate.phone"></md-input>
                                <span class="md-error" v-if="errors.phone.invalid">{{ errors.phone.msg }}</span>
                            </md-input-container>
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="50" class="container">
                            <md-input-container :class="{ 'md-input-invalid' : errors.email.invalid }">
                                <label>{{translate.pages.subordinates.edit.fields.email}}</label>
                                <md-input type="text" v-model="currentSubordinate.user.email"></md-input>
                                <span class="md-error" v-if="errors.email.invalid">{{ errors.email.msg }}</span>
                            </md-input-container>
                        </md-layout>
                    </md-layout>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="modal--footer">
                <md-button style="padding: 0 15px;" class="float-l md-primary md-size sm-size btn--cancel" @click.native="closeDialog('edit')">{{translate.pages.subordinates.edit.cancel_btn}}</md-button>
                <md-button style="padding: 0 15px;" class="float-r md-primary md-size sm-size btn--blue" @click.native="closeDialog('edit', true)" :disabled="process">{{translate.pages.subordinates.edit.accept_btn}}</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<script>
    const swal = require('sweetalert2');
    import { doctor } from '../../../config/api.js';
    import {validate_chile} from '../../../config/validators.js';
    export default {
        data: () => ({
            subordinates: [],
            roles: [],
            offices: [],
            currentSubordinate: {
                'user': {
                    'email': '',
                    'roles': [
                        {'id': ''}
                    ]
                }
            },
            newSubordinate: {
                'profile': '',
                'offices': [],
                'rut': '',
                'name': '',
                'lastname': '',
                'lastname2': '',
                'phone': '',
                'email': ''
            },
            errors: {
                'profile': {
                    'invalid': false,
                    'msg': ''
                },
                'offices': {
                    'invalid': false,
                    'msg': ''
                },
                'rut': {
                    'invalid': false,
                    'msg': ''
                },
                'name': {
                    'invalid': false,
                    'msg': ''
                },
                'lastname': {
                    'invalid': false,
                    'msg': ''
                },
                'lastname2': {
                    'invalid': false,
                    'msg': ''
                },
                'phone': {
                    'invalid': false,
                    'msg': ''
                },
                'email': {
                    'invalid': false,
                    'msg': ''
                },
                'response': {
                    'invalid': false,
                    'msg': ''
                }
            },
            selectedData: [],
            fetchData: false,
            currentIndex: -1,
            close: false,
            addButton: true,
            sort: {},
            search: {
                query: '',
                queryIsDirty: false,
                isCalculating: false,
                isQuery: false
            },
            process: false
        }),
        computed: {
            // Search indicator
            searchIndicator: function () {
                if (this.search.isCalculating) {
                    return '⟳'
                } else if (this.search.queryIsDirty) {
                    return '...'
                } else {
                    return '✓'
                }
            },
            // Get path default
            path() {
                if(!this.currentSubordinate.image){
                    return 'https://api.agendaenlinea.cl/image/default_avatar.png';
                }
                return this.currentSubordinate.image;
            },
            // Get Translate
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            },
            // Get subordinate
            subordinate(){
                return this.$store.getters.subordinate;
            }
        },
        created() {
            // Get subordinates
            this.$http.get(doctor.api.subordinates,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    // storage comunities
                    this.subordinates = data;
                    this.fetchData = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            // Get Offices
            this.$http.get(doctor.api.offices, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    if(this.subordinate.office){
                        data.map(office => {
                            if(this.subordinate.office == office.id){
                                office.checked = true;
                                this.newSubordinate.offices.push({id: office.id});
                            }
                        });
                        this.openDialog('add');
                    }
                    this.offices = data;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            // Get roles
            this.$http.get(doctor.api.roles + '?roles=true',{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.roles = data;
                    console.log(this.roles)
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            if(this.subordinate.name){
                this.newSubordinate.profile = this.subordinate.role;
                this.newSubordinate.name = this.subordinate.name;
            }
        },
        methods: {
            // Get path
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            },
            // Open modal
            openDialog(ref, row, rowIndex) {
                if(row)
                {
                    this.currentIndex = rowIndex;
                    this.currentSubordinate = JSON.parse(JSON.stringify(row));
                    if(this.currentSubordinate.user.roles.length == 0){
                        this.currentSubordinate.user.roles = [{'id': ''}];
                    }
                    this.currentSubordinate.offices.forEach(office =>{
                        this.offices.forEach(row => {
                            if(row.id == office.id)
                            {
                                row.checked = true;
                            }
                        });
                    });
                }
                this.$refs[ref].open();
            },
            // Close modal
            closeDialog(ref, save) {
                if(save)
                {
                    if(ref == 'edit')
                    {
                        this.update(ref);
                    }else{
                        this.save(ref);
                    }
                }else{
                    this.currentIndex = -1;
                    this.offices.forEach( row =>{
                        row.checked = false;
                    });
                    this.$refs[ref].close();
                    this.resetNewSubordinate();
                    this.$store.dispatch('clearSubordinate');
                }
            },
            // Show button add
            onSelect(data) {
                this.selectedData = data;
                this.$forceUpdate();
                (_.size(this.selectedData) >= 1) ? this.addButton = false : this.addButton = true;
            },
            // Sort subordinates
            onSort(sort) {
                this.subordinates = _.orderBy(this.subordinates, [item => item[sort.name]], sort.type);
            },
            // Remove subordinate
            remove(row, rowIndex){
                swal(this.translate.pages.subordinates.index.swal_remove.title, this.translate.pages.subordinates.index.swal_remove.message, 'warning')
                    .then( () => {
                        this.$http.delete(doctor.api.subordinates + '/' + row.id,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                let data = response.data.data;
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        this.subordinates.splice(rowIndex, 1);
                                    }, (dismiss) => {
                                        this.subordinates.splice(rowIndex, 1);
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Remove subordinates
            removeSubordinates(){
                swal(this.translate.pages.subordinates.index.swal_remove_subordinates.title, this.translate.pages.subordinates.index.swal_remove_subordinates.message, 'warning')
                    .then( () => {
                        var promises = [];
                        for(let index in this.selectedData)
                        {
                            let url = doctor.api.subordinates + '/' + this.selectedData[index].id;
                            promises.push(this.$http.delete(url, {
                                            headers: {
                                                Authorization : 'Bearer '+ this.$auth.getToken(),
                                            }
                                        }));
                        }
                        Promise.all(promises)
                            .then(values => {
                                var msg = '';
                                var quantites = 0;
                                values.forEach( response => {
                                    if(response.status == 200)
                                    {
                                        msg = response.data.msg;
                                        quantites++;
                                        let url = response.config.url;
                                        let id = url.split("/subordinates/")[1];
                                        this.subordinates.forEach( (office,index) => {
                                            if(office.id == id){
                                                this.subordinates.splice(index,1);
                                            }
                                        });
                                    }else{
                                        // Not deleted
                                    }
                                });
                                swal('', quantites + msg.substring(1), 'success')
                                    .then( () => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    }, (dismiss) => {
                                        this.selectedData = [];
                                        this.addButton = true;
                                    });
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Method to search
            expensiveOperation: _.debounce( function() {
                this.search.isCalculating = true;
                let data = {'query': this.search.query, 'type': 'subordinates'};
                this.$http.post(doctor.api.search, data, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.subordinates = data;
                    this.search.isCalculating = false;
                    this.search.queryIsDirty = false;
                    this.search.isQuery = true;
                }).catch(error => {
                    console.log(error);
                    //alert("No se pudo cargar las comunidades");
                });
            }, 500),
            // On chosen by office
            onChosen(add, office_id){
                if(add){
                    if(this.currentIndex > -1){
                        this.currentSubordinate.offices.push({"id": office_id});
                    }else{
                        this.newSubordinate.offices.push({"id": office_id});
                    }
                }else{
                    if(this.currentIndex > -1){
                        this.currentSubordinate.offices.find( (office, index) => {
                            if (office.id == office_id){
                                this.currentSubordinate.offices.splice(index,1);
                            }
                        });
                    }else{
                        this.newSubordinate.offices.find( (office, index) => {
                            if (office.id == office_id){
                                this.newSubordinate.offices.splice(index,1);
                            }
                        });
                    }
                }
            },
            // Upload avatar
            uploadAvatarIcon(e){
                let icon = document.getElementById('fileAvatar');
                icon.click();
            },
            // Change avatar
            onAvatarChange(e) {
              let formAvatar = document.getElementById('formAvatar');
              let formData = new FormData(formAvatar);
              formData.append('subordinate', this.currentSubordinate.id);
              let url = doctor.api.upload.subordinate;
              this.$http.post(url, formData, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    })
                    .then(response => {
                        if(response.data.status == "OK"){
                            this.currentSubordinate.image = response.data.data.image;
                            this.subordinates[this.currentIndex].image = response.data.data.image;
                        }else{
                            console.log("no se pudo");
                        }
                    }).catch(error => {
                        console.log(error);
                    });
            },
            // Store Subordinate
            save(ref){
                let error = false;
                var validation = true
                if(window.countryCODE == "cl"){
                    validation = validate_chile(this.newSubordinate.rut);
                }
                if(!validation){
                    this.errors.rut.invalid = true;
                    this.errors.rut.msg = this.translate.pages.subordinates.index.validations.rut_format;
                }
                if(this.newSubordinate.profile.length == 0)
                {
                    this.errors.profile.invalid = true;
                    this.errors.profile.msg = this.translate.pages.subordinates.index.validations.profile;
                    error = true;
                }else{
                    this.errors.profile.invalid = false;
                    this.errors.profile.msg = "";
                }
                if(this.newSubordinate.offices.length == 0)
                {
                    this.errors.offices.invalid = true;
                    this.errors.offices.msg = this.translate.pages.subordinates.index.validations.offices;
                    error = true;
                }else{
                    this.errors.offices.invalid = false;
                    this.errors.offices.msg = "";
                }
                if(this.newSubordinate.rut.length == 0)
                {
                    this.errors.rut.invalid = true;
                    this.errors.rut.msg = this.translate.pages.subordinates.index.validations.no_rut;
                    error = true;
                }else if(this.newSubordinate.rut.length > 3 && validation) {
                    this.errors.rut.invalid = false;
                    this.errors.rut.msg = "";
                }
                if(this.newSubordinate.name.length == 0)
                {
                    this.errors.name.invalid = true;
                    this.errors.name.msg = this.translate.pages.subordinates.index.validations.name;
                    error = true;
                }else{
                    this.errors.name.invalid = false;
                    this.errors.name.msg = "";
                }
                if(this.newSubordinate.phone.length == 0)
                {
                    this.errors.phone.invalid = true;
                    this.errors.phone.msg = this.translate.pages.subordinates.index.validations.phone;
                    error = true;
                }else{
                    this.errors.phone.invalid = false;
                    this.errors.phone.msg = "";
                }
                if(this.newSubordinate.email.length == 0)
                {
                    this.errors.email.invalid = true;
                    this.errors.email.msg = this.translate.pages.subordinates.index.validations.email;
                    error = true;
                }else{
                    this.errors.email.invalid = false;
                    this.errors.email.msg = "";
                }
                if(error){
                    return false;
                }
                // save Office
                this.process = true;
                this.newSubordinate.code = this.newSubordinate.rut;
                this.$http.post(doctor.api.subordinates, this.newSubordinate, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.subordinates.push(response.data.data);
                        this.$refs[ref].close();
                        this.resetNewSubordinate();
                        swal('', response.data.msg, 'success');
                        this.$store.dispatch('clearSubordinate');
                    }).catch(error => {
                        console.log(error);
                        this.process = false;
                        if(error.response.status === 401){
                            if(error.response.data.msg.max_users)
                            {
                                swal(this.translate.pages.subordinates.add.title, error.response.data.msg.max_users, 'warning');
                            }
                        }
                        else if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
            },
            // Update Subordinate
            update(ref){
                let error = false;
                if(this.currentSubordinate.user.roles[0].id.length == 0)
                {
                    this.errors.profile.invalid = true;
                    this.errors.profile.msg = this.translate.pages.subordinates.edit.validations.profile;
                    error = true;
                }else{
                    this.errors.profile.invalid = false;
                    this.errors.profile.msg = "";
                }
                if(this.currentSubordinate.offices.length == 0)
                {
                    this.errors.offices.invalid = true;
                    this.errors.offices.msg = this.translate.pages.subordinates.edit.validations.offices;
                    error = true;
                }else{
                    this.errors.offices.invalid = false;
                    this.errors.offices.msg = "";
                }
                if(this.currentSubordinate.code.length == 0)
                {
                    this.errors.rut.invalid = true;
                    this.errors.rut.msg = this.translate.pages.subordinates.edit.validations.no_rut;
                    error = true;
                }else{
                    this.errors.rut.invalid = false;
                    this.errors.rut.msg = "";
                }
                if(this.currentSubordinate.name.length == 0)
                {
                    this.errors.name.invalid = true;
                    this.errors.name.msg = this.translate.pages.subordinates.edit.validations.name;
                    error = true;
                }else{
                    this.errors.name.invalid = false;
                    this.errors.name.msg = "";
                }
                if(this.currentSubordinate.phone.length == 0)
                {
                    this.errors.phone.invalid = true;
                    this.errors.phone.msg = this.translate.pages.subordinates.edit.validations.phone;
                    error = true;
                }else{
                    this.errors.phone.invalid = false;
                    this.errors.phone.msg = "";
                }
                if(this.currentSubordinate.user.email.length == 0)
                {
                    this.errors.email.invalid = true;
                    this.errors.email.msg = this.translate.pages.subordinates.edit.validations.email;
                    error = true;
                }else{
                    this.errors.email.invalid = false;
                    this.errors.email.msg = "";
                }
                if(error){
                    return false;
                }
                // save Office
                this.process = true;
                // manually
                this.currentSubordinate.rut = this.currentSubordinate.code;
                this.currentSubordinate.profile = this.currentSubordinate.user.roles[0].id;
                this.currentSubordinate.email = this.currentSubordinate.user.email;
                this.$http.put(doctor.api.subordinates + '/' + this.currentSubordinate.id, this.currentSubordinate, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.subordinates[this.currentIndex] = response.data.data;
                        this.$refs[ref].close();
                        this.resetCurrentSubordinate();
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        this.process = false;
                        if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404 || error.response.status === 400){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
            },
            // Reset Subordinate
            resetNewSubordinate(){
                this.offices.forEach( row =>{
                    row.checked = false;
                });
                this.newSubordinate = {
                    'profile': '',
                    'offices': [],
                    'rut': '',
                    'name': '',
                    'lastname': '',
                    'lastname2': '',
                    'phone': '',
                    'email': ''
                };
            },
            // Reset Subordinate
            resetCurrentSubordinate(){
                this.currentIndex = -1;
                this.currentSubordinate = {
                    'user': {
                        'email': '',
                        'roles': [
                            {'id': ''}
                        ]
                    }
                }
            }
        },
        watch: {
            'search.query': function () {
                this.search.queryIsDirty = true;
                this.expensiveOperation();
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/loading.styl'
    .help_message
        background #FFF9C4
    .Office
        .search
            display flex
            padding 1em
            .icon
                text-align center
                width 50px
            .input
                width 100%
                input
                    border 0
                    height 2em
                    width 100%
            .button
                background-color color_main
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_main
                    color white
            .button-remove
                background-color color_error
                color white
                position absolute
                right 1em
                top 2.45em
                &:hover
                    background-color color_error
                    color white
            .status
                color color_form_placeholder
                font-size 1.5em
                left 0.35em
                position absolute
                top 0.75em
        .table
            padding 3em 2em 2em 2em
            .img
                border-radius 50%
            .name
                margin-left .5em
            .text-center
                text-align center
            .icon-edit
                color color_notifications
                cursor pointer
                font-size 22px
            .icon-delete
                color color_error
                cursor pointer
                font-size 22px
            .enabled
                border 1px solid color_form_placeholder
                border-radius 1em
                color color_form_placeholder
                margin 0 auto
                padding 0.5em 1.5em
                text-align center
                width 110px
                &.active
                    border 1px solid color_confirm
                    color color_confirm
    .content-main
        .container
            padding 0.25em 1em
            .picture
                position relative
                .icon
                    background-color color_main
                    border 3px solid white
                    border-radius 50%
                    bottom -1em
                    cursor pointer
                    height 40px
                    padding 8px
                    position absolute
                    right -1em
                    width 40px
                    text-align center
                    i
                        color white
                        position relative
                        left -3px
                        top -3px
            .multiple
                border 1px solid color_form_border
                border-radius 5px
                width 100%
                .title
                    margin 0.5em
                    color color_form_placeholder
                .select
                    overflow-y scroll
                    overflow-x hidden
                    margin 0.25em
                    height 110px
                    .option
                        width 95%
                        margin 0.25em
                .select-edit
                    overflow-y scroll
                    overflow-x hidden
                    margin 0.25em
                    height 70px
                    .option
                        width 95%
                        margin 0.25em
            .subtitle
                margin-top .5em
                color color_form_placeholder
    @import '../../../assets/styles/responsive.styl'
</style>
<style>
    .btn--cancel {
        color: #ff0000b3 !important;
    }
</style>



// WEBPACK FOOTER //
// Index.vue?403297ed